import { AccessEnum } from 'src/enums';
import { User } from 'src/typings';

export interface ShellNavItemMeta {
  showInTopNav?: boolean;
  showInDrawer?: boolean;
  tooltip?: 'orders-status';
}

export interface ShellNavItem {
  label: string;
  path: string;
  children: ShellNavItem[];
  createPath?: string;
  accent?: 'catalog' | 'parts-selection' | 'orders' | 'procurement';
  access: AccessEnum[];
  meta?: ShellNavItemMeta;
  badge?: number;
  secondaryBadge?: number;
  badgeTooltip?: string;
}

export const SHELL_NAV_ITEMS: ShellNavItem[] = [
  {
    path: '/catalogue/products',
    label: 'Справочник',
    children: [
      {
        path: '/catalogue/clients',
        label: 'Клиенты',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/catalogue/providers',
        label: 'Поставщики',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/catalogue/fiscals',
        label: 'Фискальные кассы',
        children: [],
        access: [AccessEnum.admin]
      },
      {
        path: '/catalogue/money_containers/list',
        label: 'Кассы и сейфы',
        children: [],
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/users',
        label: 'Пользователи',
        children: [],
        access: [AccessEnum.admin]
      },
      {
        path: '/city/list',
        label: 'Города',
        children: [],
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/warehouse/care',
        label: 'Порядок на складе',
        children: [],
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/warehouse/list',
        label: 'Склады',
        children: [],
        access: [AccessEnum.admin]
      },
      {
        path: '/brand-rating',
        label: 'Рейтинг брендов',
        children: [],
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/org/list',
        label: 'Организации',
        children: [],
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/news',
        label: 'Новости сайта',
        children: [],
        access: [AccessEnum.admin]
      }
    ],
    access: [AccessEnum.user, AccessEnum.admin]
  },
  {
    path: '/procurement',
    label: 'Закупка',
    children: [
      {
        path: '/procurement/minimum-stock',
        label: 'По минимальным остаткам',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/procurement/analytics',
        label: 'Аналитика закупок',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/buy/list',
        label: 'Заказы поставщикам',
        children: [],
        createPath: '/docs/buy/create',
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/docs/supplier_incoming/list',
        label: 'Приёмка поставок',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/document-receiving',
        label: 'Приёмка документов',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/document-receiving/review',
        label: 'Поступившие документы',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/document-receiving/scanners',
        label: 'Сканеры документов',
        children: [],
        access: [AccessEnum.admin]
      },
      {
        path: '/docs/contract_with_provider/list',
        label: 'Договоры с поставщиками',
        children: [],
        createPath: '/docs/contract_with_provider/create',
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/catalogue/providers',
        label: 'Поставщики',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      }
    ],
    accent: 'procurement',
    access: [AccessEnum.user, AccessEnum.admin]
  },
  {
    path: '/docs',
    label: 'Документы',
    children: [
      {
        path: '/docs/import/list',
        label: 'Приходы',
        children: [],
        createPath: '/docs/import/create',
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/export/list',
        label: 'Продажи',
        children: [],
        createPath: '/docs/export/create',
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/client_invoice/list',
        label: 'Счета клиенту',
        children: [],
        createPath: '/docs/client_invoice/create',
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/shipment_by_invoice/list',
        label: 'Отгрузка по счету',
        children: [],
        createPath: '/docs/shipment_by_invoice/create',
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/return_to_warehouse/list',
        label: 'Возвраты на склад',
        children: [],
        createPath: '/docs/return_to_warehouse/create',
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/return_to_provider/list',
        label: 'Возвраты поставщику',
        children: [],
        createPath: '/docs/return_to_provider/create',
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/moving/list',
        label: 'Движение товара',
        children: [],
        createPath: '/docs/moving/create',
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/docs/stocktaking-v2/list',
        label: 'Переучет',
        children: [],
        createPath: '/docs/stocktaking-v2/create',
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/docs/write_off_products/list',
        label: 'Списание товаров',
        children: [],
        createPath: '/docs/write_off_products/create',
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/docs/surplus_products/list',
        label: 'Оприходование излишков',
        children: [],
        createPath: '/docs/surplus_products/create',
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/docs/regrading_products/list',
        label: 'Пересорт товаров',
        children: [],
        createPath: '/docs/regrading_products/create',
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/docs',
        label: 'Деньги',
        children: [
          {
            path: '/docs/money_day/list',
            label: 'Смены',
            children: [],
            access: [AccessEnum.admin, AccessEnum.user]
          },
          {
            path: '/docs/money_collection/list',
            label: 'Инкассации',
            children: [],
            access: [AccessEnum.admin, AccessEnum.user]
          },
          {
            path: '/docs/money_event/list',
            label: 'Журнал денег',
            children: [],
            access: [AccessEnum.admin, AccessEnum.user]
          },
          {
            path: '/docs/settlement_with_provider/list',
            label: 'Оплата поставщику',
            children: [],
            createPath: '/docs/settlement_with_provider/create',
            access: [AccessEnum.admin]
          },
          {
            path: '/docs/client_invoice_payment/list',
            label: 'Оплата по счетам клиенту',
            children: [],
            createPath: '/docs/client_invoice_payment/create',
            access: [AccessEnum.admin, AccessEnum.user]
          },
          {
            path: '/docs/client_invoice_refund/list',
            label: 'Возврат денег клиенту',
            children: [],
            createPath: '/docs/client_invoice_refund/create',
            access: [AccessEnum.admin, AccessEnum.user]
          },
          {
            path: '/docs/money_adjustment/list',
            label: 'Корректировки денег',
            children: [],
            createPath: '/docs/money_adjustment/create',
            access: [AccessEnum.admin]
          },
          {
            path: '/docs/money_transfer/list',
            label: 'Переводы денег',
            children: [],
            createPath: '/docs/money_transfer/create',
            access: [AccessEnum.admin]
          }
        ],
        access: [AccessEnum.admin, AccessEnum.user]
      }
    ],
    access: [AccessEnum.user, AccessEnum.admin]
  },
  {
    path: '/reports',
    label: 'Отчеты',
    children: [
      {
        path: '/reports/contracts',
        label: 'Задолженость по договорам',
        children: [],
        access: [AccessEnum.admin]
      },
      {
        path: '/reports/ledger',
        label: 'Взаиморасчеты с поставщиками',
        children: [],
        access: [AccessEnum.admin]
      },
      {
        path: '/customer-accounts',
        label: 'Взаиморасчеты с клиентами',
        children: [],
        access: [AccessEnum.admin, AccessEnum.user]
      },
      {
        path: '/reports/manager-profit',
        label: 'Отчет по прибыли',
        children: [],
        access: [AccessEnum.admin]
      },
      {
        path: '/b2c-analytics',
        label: 'Аналитика сайта',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      }
    ],
    access: [AccessEnum.admin, AccessEnum.user]
  },
  {
    path: '/calls',
    label: 'Звонки',
    children: [
      {
        path: '/calls',
        label: 'Журнал звонков',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      },
      {
        path: '/callbacks',
        label: 'Перезвоны',
        children: [],
        access: [AccessEnum.user, AccessEnum.admin]
      }
    ],
    access: [AccessEnum.user, AccessEnum.admin]
  },
  {
    path: '/new-catalog',
    label: 'Каталог',
    children: [],
    accent: 'catalog',
    access: [AccessEnum.user, AccessEnum.admin]
  },
  {
    path: '/parts-selection',
    label: 'Подборы',
    children: [],
    accent: 'parts-selection',
    access: [AccessEnum.user, AccessEnum.admin]
  },
  {
    path: '/orders',
    label: 'Заказы',
    children: [],
    accent: 'orders',
    access: [AccessEnum.user, AccessEnum.admin],
    meta: {
      tooltip: 'orders-status'
    }
  }
];

export function filterShellNavItems(
  sourceItems: ShellNavItem[],
  user: User | undefined
): ShellNavItem[] {
  const isAdmin = user?.roles?.some((role) => role.description === 'admin') === true;

  return sourceItems
    .map((item) => ({
      ...item,
      children: filterShellNavItems(item.children || [], user)
    }))
    .filter((item) => (isAdmin ? true : item.access.includes(AccessEnum.user)));
}

function normalizeShellUrl(url: string) {
  return String(url || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/\/+$/, '');
}

function shellNavPathMatches(itemPath: string, currentUrl: string) {
  const normalizedPath = normalizeShellUrl(itemPath);
  if (!normalizedPath) {
    return false;
  }

  if (normalizedPath === currentUrl) {
    return true;
  }

  return currentUrl.startsWith(`${normalizedPath}/`);
}

export function isShellNavItemActive(item: ShellNavItem, url: string): boolean {
  const currentUrl = normalizeShellUrl(url);
  if (shellNavPathMatches(item.path, currentUrl)) {
    return true;
  }

  if (item.createPath && shellNavPathMatches(item.createPath, currentUrl)) {
    return true;
  }

  return (item.children || []).some((child) => isShellNavItemActive(child, currentUrl));
}
